import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, Pencil } from "lucide-react";
import { Button } from "./ui/button";
import { StatusPill } from "./StatusBadge";

// The server lists what a customer profile lacks (see customer_completeness.py).
// Nothing here blocks: quotes and rentals go ahead, the profile is completed later.

export const isIncomplete = (client) => client?.completeness?.complete === false;
export const missingText = (client) => (client?.completeness?.missing || []).join(" · ");

export function CompletenessPill({ client }) {
  if (!isIncomplete(client)) return null;
  return (
    <StatusPill tone="tone-amber" title={`Mancano: ${missingText(client)}`} data-testid={`client-incomplete-${client.id}`}>
      Da completare
    </StatusPill>
  );
}

function Notice({ title, children, action, testId }) {
  return (
    <div role="status" className="tone-amber flex flex-wrap items-center justify-between gap-3 rounded-xl border p-4 text-sm"
      style={{ borderColor: "var(--tone-line)", background: "var(--tone-fill)" }} data-testid={testId}>
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <ClipboardList className="mt-0.5 h-5 w-5 shrink-0" style={{ color: "var(--tone-ink)" }} aria-hidden="true" />
        <div className="min-w-0">
          <p className="font-semibold" style={{ color: "var(--tone-ink)" }}>{title}</p>
          <p className="break-words">{children}</p>
        </div>
      </div>
      {action}
    </div>
  );
}

/** Banner at the top of the customer profile. */
export function CompletenessNotice({ client, onComplete }) {
  if (!isIncomplete(client)) return null;
  return (
    <Notice title="Scheda da completare" testId="client-completeness"
      action={onComplete && <Button size="sm" onClick={onComplete} data-testid="client-complete-now"><Pencil aria-hidden="true" />Completa la scheda</Button>}>
      Mancano: {missingText(client)}
    </Notice>
  );
}

/** Warning under the customer field of a quote or rental: it does not stop saving. */
export function ClientFormWarning({ client }) {
  if (!isIncomplete(client)) return null;
  return (
    <Notice title="Scheda cliente da completare" testId="client-form-warning"
      action={<Link to={`/clienti/${client.id}`} className="text-sm font-medium text-primary underline-offset-4 hover:underline">Apri la scheda</Link>}>
      Mancano: {missingText(client)}. Puoi proseguire; completala prima della consegna.
    </Notice>
  );
}
